export default function StatusIcon({ status }: { status: 'complete' | 'current' }) {
  if (status === 'complete') {
    return (
      <svg
        width='42'
        height='42'
        viewBox='0 0 42 42'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        role='img'
        aria-label='Status complete icon'
      >
        <title>Status complete</title>
        <g filter='url(#filter0_dd_600_13301)'>
          <mask id='path-1-inside-1_600_13301' fill='white'>
            <path d='M5 17C5 8.16344 12.1634 1 21 1C29.8366 1 37 8.16344 37 17C37 25.8366 29.8366 33 21 33C12.1634 33 5 25.8366 5 17Z' />
          </mask>
          <path
            d='M5 17C5 8.16344 12.1634 1 21 1C29.8366 1 37 8.16344 37 17C37 25.8366 29.8366 33 21 33C12.1634 33 5 25.8366 5 17Z'
            fill='#EBF4E7'
            shapeRendering='crispEdges'
          />
          <path
            d='M21 33V31C13.268 31 7 24.732 7 17H5H3C3 26.9411 11.0589 35 21 35V33ZM37 17H35C35 24.732 28.732 31 21 31V33V35C30.9411 35 39 26.9411 39 17H37ZM21 1V3C28.732 3 35 9.26801 35 17H37H39C39 7.05887 30.9411 -1 21 -1V1ZM21 1V-1C11.0589 -1 3 7.05887 3 17H5H7C7 9.26801 13.268 3 21 3V1Z'
            fill='#388E10'
            mask='url(#path-1-inside-1_600_13301)'
          />
          <path
            d='M15 18.3L17.7692 21L27 12'
            stroke='#388E10'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <filter
            id='filter0_dd_600_13301'
            x='0'
            y='0'
            width='42'
            height='42'
            filterUnits='userSpaceOnUse'
            colorInterpolationFilters='sRGB'
          >
            <feFlood floodOpacity='0' result='BackgroundImageFix' />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feMorphology radius='2' operator='erode' in='SourceAlpha' result='effect1_dropShadow_600_13301' />
            <feOffset dy='2' />
            <feGaussianBlur stdDeviation='2' />
            <feComposite in2='hardAlpha' operator='out' />
            <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0' />
            <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_600_13301' />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feMorphology radius='1' operator='erode' in='SourceAlpha' result='effect2_dropShadow_600_13301' />
            <feOffset dy='4' />
            <feGaussianBlur stdDeviation='3' />
            <feComposite in2='hardAlpha' operator='out' />
            <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0' />
            <feBlend mode='normal' in2='effect1_dropShadow_600_13301' result='effect2_dropShadow_600_13301' />
            <feBlend mode='normal' in='SourceGraphic' in2='effect2_dropShadow_600_13301' result='shape' />
          </filter>
        </defs>
      </svg>
    )
  } else if (status === 'current') {
    return (
      <svg
        width='42'
        height='42'
        viewBox='0 0 42 42'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        role='img'
        aria-label='Status current icon'
      >
        <title>Status current</title>
        <g filter='url(#filter0_dd_921_14736)'>
          <mask id='path-1-inside-1_921_14736' fill='white'>
            <path d='M5 17C5 8.16344 12.1634 1 21 1C29.8366 1 37 8.16344 37 17C37 25.8366 29.8366 33 21 33C12.1634 33 5 25.8366 5 17Z' />
          </mask>
          <path
            d='M5 17C5 8.16344 12.1634 1 21 1C29.8366 1 37 8.16344 37 17C37 25.8366 29.8366 33 21 33C12.1634 33 5 25.8366 5 17Z'
            fill='#D0D8F1'
            shapeRendering='crispEdges'
          />
          <path
            d='M21 33V31C13.268 31 7 24.732 7 17H5H3C3 26.9411 11.0589 35 21 35V33ZM37 17H35C35 24.732 28.732 31 21 31V33V35C30.9411 35 39 26.9411 39 17H37ZM21 1V3C28.732 3 35 9.26801 35 17H37H39C39 7.05887 30.9411 -1 21 -1V1ZM21 1V-1C11.0589 -1 3 7.05887 3 17H5H7C7 9.26801 13.268 3 21 3V1Z'
            fill='#153CB7'
            mask='url(#path-1-inside-1_921_14736)'
          />
          <path
            d='M21 9C25.4 9 29 12.6 29 17C29 21.4 25.4 25 21 25C16.6 25 13 21.4 13 17C13 12.6 16.6 9 21 9ZM20.2002 13V17.7998L24.3604 20.3604L25 19.3203L21.4004 17.1602V13H20.2002Z'
            fill='#153CB7'
          />
        </g>
        <defs>
          <filter
            id='filter0_dd_921_14736'
            x='0'
            y='0'
            width='42'
            height='42'
            filterUnits='userSpaceOnUse'
            colorInterpolationFilters='sRGB'
          >
            <feFlood floodOpacity='0' result='BackgroundImageFix' />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feMorphology radius='2' operator='erode' in='SourceAlpha' result='effect1_dropShadow_921_14736' />
            <feOffset dy='2' />
            <feGaussianBlur stdDeviation='2' />
            <feComposite in2='hardAlpha' operator='out' />
            <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0' />
            <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_921_14736' />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feMorphology radius='1' operator='erode' in='SourceAlpha' result='effect2_dropShadow_921_14736' />
            <feOffset dy='4' />
            <feGaussianBlur stdDeviation='3' />
            <feComposite in2='hardAlpha' operator='out' />
            <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0' />
            <feBlend mode='normal' in2='effect1_dropShadow_921_14736' result='effect2_dropShadow_921_14736' />
            <feBlend mode='normal' in='SourceGraphic' in2='effect2_dropShadow_921_14736' result='shape' />
          </filter>
        </defs>
      </svg>
    )
  }
  return null
}
